const getFactorsByFilter = (rawFactors = [], filteredType = '') => {
  if (filteredType === 'year') {
    const semester1Factors = rawFactors.filter(x => x.semesterType === 'semester-1').sort((a, b) => a.index - b.index)
    const semester2Factors = rawFactors.filter(x => x.semesterType === 'semester-2').sort((a, b) => a.index - b.index)
    return [...semester1Factors, ...semester2Factors]
  }
  return rawFactors.filter(x => x.semesterType === filteredType).sort((a, b) => a.index - b.index)
}

const setMaxColumnForSemester = (semesters = [], sortedFactors = []) => {
  return semesters.map(s => {
    return {
      ...s,
      maxColumn: sortedFactors
        .filter(x => x.semesterType === s.type)
        .map(x => x.maxColumn)
        .reduce((a, c) => a + c, 0),
    }
  })
}

export { getFactorsByFilter, setMaxColumnForSemester }
